module.exports = __webpack_public_path__ + "img/image_14.44248bf8.png";